import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import BasicButton from '@hems/component/src/buttons/BasicButton.vue';
import { AuthHelper } from '@hems/util';
export default defineComponent({
    name: 'UnauthorizedPage',
    components: {
        BasicButton,
    },
    setup() {
        AuthHelper.removeAuthToken();
        const router = useRouter();
        const goHome = () => {
            router.push({
                path: '/',
            });
        };
        return {
            goHome,
        };
    },
});
